import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../components/common/SectionHeading';

const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};

  @media (max-width: 768px) {
    padding: 1.75rem;
  }
`;

const Banner = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 1.5rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '🎨';
    font-size: 8rem;
    opacity: 0.3;
    position: absolute;
  }

  @media (max-width: 768px) {
    height: 200px;
    margin-bottom: 2rem;

    &::before {
      font-size: 5rem;
    }
  }
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.6;
  margin: 1.5rem 0 2.5rem;
`;

const ProgramSection = styled.div`
  margin-top: 3rem;
  padding-top: 2.5rem;
  border-top: 2px solid ${({ theme }) => theme.colors.surfaceMuted};
`;

const ProgramGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const ProgramCard = styled.a`
  display: block;
  padding: 2.5rem;
  background: ${({ theme }) => theme.colors.surfaceMuted};
  border-radius: 1.25rem;
  border: 2px solid ${({ theme }) => theme.colors.primary}15;
  transition: ${({ theme }) => theme.transitions.default};
  text-decoration: none;
  color: inherit;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary}30;
    box-shadow: ${({ theme }) => theme.shadows.md};
    transform: translateY(-4px);
  }
`;

const ProgramIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const ProgramTitle = styled.h3`
  margin: 0 0 1rem;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
`;

const ProgramDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.6;
  text-align: center;
`;

const programs = [
  {
    title: '기초반',
    icon: '🎯',
    description: '코딩의 기초를 차근차근 배우는 과정',
    link: '#',
  },
  {
    title: '자격증반',
    icon: '🏆',
    description: '코딩 자격증 취득을 위한 전문 과정',
    link: '#',
  },
  {
    title: 'IoT로봇코딩반',
    icon: '🤖',
    description: 'IoT와 로봇을 활용한 실전 코딩 교육',
    link: '#',
  },
];

const ElementaryProgramPage = () => (
  <Wrapper>
    <Banner />
    <SectionHeading
      eyebrow="초등 프로그램"
      title="초등 코딩 교육 프로그램"
    />
    <Subtitle>
      초등학생을 위한 창의적이고 재미있는 코딩 교육 프로그램입니다.<br />
      놀이와 학습을 결합하여 자연스럽게 프로그래밍의 기초를 익히고, 논리적 사고력과 문제 해결 능력을 키울 수 있습니다.
    </Subtitle>
    <ProgramSection>
      <ProgramGrid>
        {programs.map((program) => (
          <ProgramCard key={program.title} href={program.link}>
            <ProgramIcon>{program.icon}</ProgramIcon>
            <ProgramTitle>{program.title}</ProgramTitle>
            <ProgramDescription>{program.description}</ProgramDescription>
          </ProgramCard>
        ))}
      </ProgramGrid>
    </ProgramSection>
  </Wrapper>
);

export default ElementaryProgramPage;

